export * from "./locales.ts";
export * from "./display-name.ts";
export { en, type MessageKey, type MessagePack } from "./messages/en.ts";
export { km, KM_AWAITING_REVIEW } from "./messages/km.ts";
export { es, ES_AWAITING_REVIEW } from "./messages/es.ts";
export { th, TH_AWAITING_REVIEW } from "./messages/th.ts";

import { en } from "./messages/en.ts";
import { km } from "./messages/km.ts";
import { es } from "./messages/es.ts";
import { th } from "./messages/th.ts";
import { DEFAULT_LOCALE, type Locale } from "./locales.ts";
import type { MessagePack } from "./messages/en.ts";

const PACKS: Partial<Record<Locale, MessagePack>> = { en, km, es, th };

/**
 * The base pack for a locale, falling back to English. A locale with no pack —
 * `zh` today — resolves to English rather than to blanks, so adding a locale to
 * the registry before its pack exists degrades instead of breaking.
 */
export function messagePack(code: Locale): MessagePack {
  return PACKS[code] ?? PACKS[DEFAULT_LOCALE] ?? en;
}
